/* istanbul ignore file */

import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import listerReducer from './../reducers/lister-reducer';
import { updateDocumentInformation } from './document-middleware';
import { taggingMiddleWare } from './tagging-middleware';

let composeEnhancers = compose;

//eslint-disable-next-line no-process-env,no-undef
if (process.env.NODE_ENV === 'development') {
	//eslint-disable-next-line no-underscore-dangle
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const ListerStore = createStore(
	listerReducer,
	composeEnhancers(
		applyMiddleware(thunk, taggingMiddleWare, updateDocumentInformation)
	)
);

export default ListerStore;
